/*
 * @Author: zhushitao
 * @Date: 2021-10-27 16:52:48
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-27 16:53:50
 * @Description:
 */

/**
 * @description Tentatively set as jarvis  event code
 */
export enum EventCode {
  TransferEventCode = 'transferEventCode',
  TriggerJarvisEventCode = 'triggerJarvisEventCode',
  CreateDialogEventCode = 'CreateDialogEventCode',
  EndDialogEventCode = 'EndDialogEventCode',
}
